import { forwardRef } from 'react';
import dynamic from 'next/dynamic';
import { useTranslations } from 'next-intl';

import styles from './Select.module.css';

const Select = dynamic(() => import('react-select'), {
  ssr: false,
  loading: () => null,
});

function SelectView(props, ref) {
  const {
    className = '',
    isFocused,
    label,
    placeholder,
    icon,
    withoutBG,
    options,
    error,
    errorText,
    onChange,
    onClick,
    value,
    onBlur,
    onFocus,
    dataTestid,
    disabled,
    menuIsOpen,
    onMenuOpen,
  } = props;
  const t = useTranslations();
  return (
    <div
      className={`${styles.box} ${error ? styles.box_error : ''} ${withoutBG ? styles.box_without_bg : ''} search-input-box ${
        isFocused ? styles.box_focused : ''
      } ${className} ${withoutBG ? '!h-14' : ''} ${withoutBG ? styles.without_bg : ''} ${disabled ? styles.box_disabled : ''}`}
      ref={ref}
      data-guestit-error={error}
      data-testid={dataTestid}
      onClick={onClick}
    >
      <div className={styles.input}>
        <span
          className={`icon-input inline-flex relative top-[-3px] ${styles.icon} ${error && '!text-rose-400'} ${
            isFocused ? '!text-teal-600' : ''
          }`}
        >
          <i className={`text-[24px] h-6 ${icon}`} />
        </span>

        <div className={`flex flex-col gap-2 w-full relative ${className}`}>
          <label className="text-xs text-slate-600 truncate inline-block h-[18px] mt-[-4px] mb-[-4px]">
            <span>{t(label)}</span>
          </label>
          <Select
            classNamePrefix="react-select"
            options={options}
            placeholder={t(placeholder)}
            isSearchable={false}
            onChange={onChange}
            value={value}
            onBlur={onBlur}
            onFocus={onFocus}
            isDisabled={disabled}
            menuIsOpen={menuIsOpen}
            onClick={onClick}
            onMenuOpen={onMenuOpen}
          />
          {error && (
            <i className="icon-error absolute right-0 top-0.5 leading-6 text-[24px] text-rose-400" />
          )}
        </div>
      </div>
      {errorText && (
        <div className="absolute -bottom-6 text-white text-xs font-normal leading-[18px] truncate max-sm:inset-x-0">
          {t(errorText)}
        </div>
      )}
    </div>
  );
}

export const SelectBox = forwardRef(SelectView);
